import alt from '../alt';
export default alt.createActions({
  /**
   * A new process is loading
   */
  addProcess: () => true,
  /**
   * A process stop loading
   */
  removeProcess: () => true,
  startApp: () => true,
});
